import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./NoCommentsContent.module.scss";
import { NoComments } from "@/frontend/shared/assets/NoComments";

export function NoCommentsContent() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.imageContainer}>
        <NoComments />
      </div>
      <Typography variant="body-3" color="greyscale600">
        No comments yet
      </Typography>
    </div>
  );
}
